import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
@Component({
  selector: 'app-print-invoice',
  templateUrl: './print-invoice.component.html',
  styleUrls: ['./print-invoice.component.scss']
})
export class PrintInvoiceComponent implements OnInit {
  todaysdate:any
  constructor(public dialog: MatDialog, public datepipe: DatePipe, public authService: AuthService,
    public opdvisitService: OpdVisitService,) { }

  ngOnInit(): void {
  }
  closedialog(){
    this.dialog.closeAll();
    }
}
